import { signal } from '@preact/signals-react';
import { getFeatureFlags } from 'core/flow-control';

const PRINT_MODE_CLASS = 'print-mode';
export const printModeSignal = signal(false);

export const enterPrintMode = () => {
  printModeSignal.value = true;
  document.body.classList.add(PRINT_MODE_CLASS);
};

export const exitPrintMode = () => {
  const { accessibility_property_print_preview_ff } = getFeatureFlags();

  printModeSignal.value = false;
  document.body.classList.remove(PRINT_MODE_CLASS);

  if (accessibility_property_print_preview_ff) {
    document.querySelector<HTMLElement>('[data-testid="widget-help-button"]')?.focus();
  }
};
